import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NotificationHubComponent} from './notification-hub/notification-hub.component';
import {CoreModule} from "../core/core.module";
import {SharedModule} from "../shared/shared.module";
import {SidebarModule} from "primeng/sidebar";
import {ScrollerModule} from "primeng/scroller";
import {SharedGenericModule} from '../shared/shared-generic/shared-generic.module';

@NgModule({
    declarations: [
        NotificationHubComponent
    ],
    exports: [
        NotificationHubComponent
    ],
    imports: [
        CommonModule,
        CoreModule,
        SharedGenericModule,
        SharedModule,
        SidebarModule,
        ScrollerModule
    ]
})
export class NotificationModule {
}
